import { Component, OnInit, SimpleChanges,AfterViewInit, ElementRef, OnDestroy, ViewChild, HostListener } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import videojs from 'video.js';
import { TranslateService } from '@ngx-translate/core';
import { LivestreamService } from 'src/app/Core/services/livestream.service';
import { UtilService } from 'src/app/Core/services/util.service';
import { Subscription, interval } from 'rxjs';
import * as moment from 'moment';
import { Constant } from '../../services/data';
import * as _ from 'lodash';
import { CategoryService } from '../../services/category.service';
import { HttpClient } from '@angular/common/http';
import { ImageProxyService } from '../../services/image-proxy-service';
import {LiveUrlModel} from '../../models/liveTvFormat.model'
import { PlaylistService } from '../../services/playlist.service';
import { Livetv } from '../../services/livestream.service';
declare let shaka: any;
const Plyr = require('plyr');
declare var require: any;
declare var Hls;
interface Category {
  category_id: string;
  category_name: string;
}
@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})
export class CategoriesComponent implements OnInit,OnDestroy,AfterViewInit {
  @ViewChild('channelbox', { static: false }) private channelboxScroll: ElementRef;
  isCategory: boolean = false;
  isChannels: boolean = false;
  isLoading: boolean = false;
  isChannelLoading: boolean = false;
  isDefaultButton: boolean = false;
  categoryId: any;
  selectedchannel: any;
  channelImage:any
  sortType: any;
  defaultCategoryList: any;
  liveCategoryList: any;
  searchedLiveCatList:any;
  channels: any;
  defaultChannels:any;
  searchedChannel:any;
  subscription: Subscription;
  records: Array<any>;
  epgdata: any;
  displayEpg: any = [];
  epgId:any
  channelname: any;
  hello: any;
  start: any;
  end: any;
  dash = ' ';
  MOVIEDatas = [
  ]
  CHANNELDatas = [
  ]
  player:any
  hls: any;
  Url: any;
  url: string;
  filterTerm: string;
  initial_Url: string;
  basetitle: any;
  basedesciption: any;
  timedata: any;
  video;
  videoPlaying: boolean;
  percentage;
  displayURL;
  vlcUrl: any
  newUrl: any
  epgid:any
  catSelected:boolean = false
  channel_id:any;
  allCatSelected:boolean = false
  unixTime: number;
  timer:any
  currentTimer:any;
  loadLiveTv:boolean = false
  searchText:any;
  searchNoData:any=1;
  showAll:boolean = true;
  isCheckboxChecked:boolean = true;
  sourceType:string ='application/x-mpegURL';
  formatType:string ='.m3u8';
  @ViewChild('popover') popover: any;
  sortButton: any = [{ label: 'Default', val: 'default', selected: true },
  { label: 'A - Z', val: 'atoz', selected: false },
  { label: 'Z - A', val: 'ztoa', selected: false },
  ];
  translation=['COMMON.DEFAULT','COMMON.A-Z','COMMON.Z-A']
  OToken:any;
  liveUrl: LiveUrlModel = {
    m3u8: '',
    ts: ''
  };
  isLocal:boolean= true;
  profile_id:any;
  stream_Url: any;
  liveData:any;
  profileData:any;
  fav_id:any;
  favData:any;

  isLoadingMore: boolean = false;
  categories: Category[] = [];
  livetv : Livetv[]=[]
  selectedCategoryId = '';
  page = 1;
  limit = 50;



  constructor(private http: HttpClient,private imageProxyService:ImageProxyService ,private categoriesService: CategoryService, private liveStreamService: LivestreamService, private route: ActivatedRoute, private utilService: UtilService, private sanitizer: DomSanitizer, public translate: TranslateService,private playlistService:PlaylistService) {
    this.subscription = this.utilService.getSorting().subscribe((res: any) => {
      this.sortType = res;
      if (this.sortType.type == 'Livetv') {
        this.sort('category_name', this.sortType.sub_category);
      }
    });
  
    this.sort('Default', 'default');
    if (this.popover) {
      this.popover.hide();
    }
    this.utilService.filterReset$.subscribe((flag: any) => {
      if (flag) {
        this.sort('Default', 'default');
        if (this.popover) {
          this.popover.hide();
        }
      }
    });
    this.formatType=localStorage.getItem('formatType') || this.formatType;
    if(this.formatType == '.m38'){
       this.sourceType = 'application/x-mpegURL';
    }else if(this.formatType == '.ts'){
      this.sourceType = 'application/vnd.apple.mpegurl';
    }else{
      this.sourceType = 'application/x-mpegURL';
    }
    this.OToken = this.utilService.getOneStreamToken();

  }

 async ngOnInit() {
    this.route.queryParams.subscribe((param: any) => {
      if (param) {
        console.log('params',param);
        
        if (param.stream) {
          this.selectedchannel = param.stream;
        }
        if (param.category){
          this.categoryId = param.category;
          setTimeout(() => {
            this.onCategorySelect(this.categoryId)
            const stream = param.stream;
            this.updateChannel(stream,'')
            this.updateChannelEpg('93238','ue',this.channelImage)
          }, 500);
        }else{
          setTimeout(() => {
            this.onCategorySelect('all');
            this.allCatSelected =true
          }, 500);
        }
        // this.onCategorySelect(this.categoryId)
      }


      // this.updateChannelEpg(this.selectedchannel, this.categoryId ,this.channelImage)
    });
    this.currentTimer = setInterval(() => {
      this.updateTime();
    }, 1000);
    // console.log(this.timer,'timers-----------------');
    console.log(this.searchText,'searched!');
    const profileData = JSON.parse(localStorage.getItem('Profile') || '{}');
    const mtoken = localStorage.getItem('mtoken') || '{}'
    if(mtoken === '{}'){
      this.isLocal = true;
    }else{
      this.isLocal = false;
    }
    this.profile_id = profileData.profile_id;
    
    // this.getCategoriesList();
    // this.getLiveCategory();
    this.getFavData()
    console.log("categories not found", this.categoryId);
    if (!this.categoryId) {
      // this.getChannelList(131);
      // this.getNewChannelList('',null);
    }
    this.video = document.getElementsByTagName("video")[0];
    this.initial_Url = 'https://vmp.one/live/jum/quin/191835.m3u8';
    this.categories = await this.liveStreamService.loadLivetvCategories();
    this.defaultCategoryList = this.categories;
    this.liveCategoryList = this.categories;
    // this.liveCategoryList = this.channels;
  
    this.searchedLiveCatList = this.liveCategoryList;
    // console.log(this.categories);
    
  }
 
async onCategorySelect(categoryId: string) {
  console.log(categoryId);
  
  this.selectedCategoryId = categoryId;
  this.page = 1;

  if (categoryId === 'all') {
    this.livetv = await this.liveStreamService.getAllChannel(this.page, this.limit);
    this.channels = this.livetv;
    this.defaultChannels = this.livetv;
    this.searchedChannel = this.livetv;
    this.allCatSelected = true;
    this.liveCategoryList.map((ele: any, index) => {
      (ele.category_id == categoryId) ? ele.select = true : ele.select = false;
    });
     this.searchedChannel.map((ele: any, index) => { 
      this.updateChannel(ele.stream_id,ele.links);
      this.updateChannelEpg(ele.stream_id,ele.name,ele.stream_icon)
     })
  }
  else {
    this.livetv = await this.liveStreamService.getLivetvByCategory(categoryId, this.page, this.limit);
    this.channels = this.livetv;
     this.defaultChannels = this.livetv;
    this.searchedChannel = this.livetv;
    const filter = this.searchedChannel;
    this.allCatSelected = false;
      this.liveCategoryList.map((ele: any, index) => {
      (ele.category_id == categoryId) ? ele.select = true : ele.select = false;
    });
     filter.map((ele: any, index) => { 
       this.updateChannel(ele.stream_id,ele.links);
       setTimeout(() => {
         
         this.updateChannelEpg(ele.stream_id,ele.name,ele.stream_icon)
        }, 500);
   
     })

    console.log(this.livetv);
  }

  console.log(`Loaded ${this.livetv.length} movies for '${categoryId}'`);
}

async loadMore() {
  if (this.isLoadingMore) return;

  this.isLoadingMore = true;
  this.page++;

  let more: Livetv[] = [];

  if (this.selectedCategoryId === 'all') {
    more = await this.liveStreamService.getAllChannel(this.page, this.limit);
  } else {
    more = await this.liveStreamService.getLivetvByCategory(this.selectedCategoryId, this.page, this.limit);
  }

  this.livetv = this.livetv.concat(more);
  this.channels = [...this.livetv];
  this.defaultChannels = [...this.livetv];
  this.searchedChannel = [...this.livetv];
  console.log(this.livetv);
  
  this.isLoadingMore = false;
}


// @HostListener('window:scroll', [])
// onScroll(): void {
//   const scrollPosition = window.innerHeight + window.scrollY;
//   const pageHeight = document.body.offsetHeight;

//   if (scrollPosition >= pageHeight - 100 && !this.isLoadingMore) {
//     this.loadMore();
//     alert('mahadev')
//   }
// }
onChannelBoxScroll(event: any): void {
  const native = event.target;
  const atBottom = native.scrollTop + native.clientHeight >= native.scrollHeight - 100;

  if (atBottom && !this.isLoadingMore) {
    this.loadMore();
  }
}


  
  getFavData(){
    this.playlistService.getAllFavData(this.profile_id).subscribe((res:any) =>
    {
      this.liveData = res;
      this.favData = this.liveData.filter( type => type.content_type == 'live');
      let index;
      this.favData.map((ele: any) => {
      console.log(ele);     
      index = _.findIndex(this.channels, { stream_id: ele.content_id });
      if (index >= 0) {
              this.channels[index].isFavourit = true;
              this.fav_id = this.favData[0].favorite_id;
          }
          });//for favourit
      console.log(this.liveData,this.favData);
    })
  }
  getProxiedImageUrl(url: string): string {
    return this.imageProxyService.getProxiedImageUrl(url);
  }
  ngAfterViewInit():void{
  // this.player = videojs('live-video')
  // this.player.on('play', () => {
  //   this.player.removeChild('BigPlayButton')

  // })
  // this.player.on('pause', () => {
  //   this.player.addChild('BigPlayButton')
  // })
  }
  
  getCategoriesList() {
    this.isLoading = true
    this.categoriesService.get().subscribe((res: any) => {
      this.isLoading = false
      // console.log(res,'res')
      // this.liveCategoryList = res;
      // this.defaultCategoryList = res;
      if (this.liveCategoryList) {
        this.liveCategoryList.map((ele: any, index) => {
          if (this.categoryId) {

            if (ele.category_id == this.categoryId) {

              ele.select = true;
              setTimeout(() => {
                //   document.getElementById("button" + ele.category_id).scrollIntoView();
                $(".category-box").animate({ scrollTop: $("#button" + ele.category_id).position().top }, 200, 'swing');
              }, 300);

              this.getChannelList(this.categoryId)
            }
          } else {
            if (index == 0) {
              ele.select = true;
              this.getChannelList(ele.category_id);
              console.log("categories id", ele.category_id);
            } else {
              ele.select = false;
            }
          }
        });
      }
    }, err => {
      this.isLoading = false;
      this.utilService.showErrorCall(err);
    })

  }

  searchTexts(eve:any){
    console.log(eve.srcElement.value,this.searchText);
    let search = this.searchText.toLowerCase();
    if (this.searchText.length >= 1) {
      this.searchedLiveCatList = this.liveCategoryList.filter((cat: any) => {
        return cat.category_name.toLowerCase().includes(search);
      });
      this.searchNoData = this.searchedLiveCatList.length;
      if(this.searchNoData > 0){
        this.showAll = true
      }else{
        this.showAll = false  
      }

      console.log(this.searchedLiveCatList.length,'its lenghts');
      
    } else {
      this.searchedLiveCatList = this.liveCategoryList;
      this.showAll = true;
    }    
  }

  clearSearch(){
      this.searchText='';
      this.searchedLiveCatList = this.liveCategoryList;
      this.showAll = true;
      this.searchNoData=1
      console.log(this.searchedLiveCatList.length,'categories..........');
      
  }

  getLiveCategory() {
    this.isLoading = true;
    this.utilService.showSpinner()
    this.liveStreamService.getliveCategories().subscribe((res: any) => {
      if(res.content)
      {
        this.liveCategoryList = res.content;
        this.defaultCategoryList = res.content;
        this.searchedLiveCatList =this.liveCategoryList;
        if (this.liveCategoryList) {
          this.liveCategoryList.map((ele: any, index) => {
          if (this.categoryId) {
            if (ele.category_id == this.categoryId) {
              ele.select = true;
              setTimeout(() => {
                //   document.getElementById("button" + ele.category_id).scrollIntoView();
                $(".category-box").animate({ scrollTop: $("#button" + ele.category_id).position().top }, 200, 'swing');
              }, 300);
              this.getChannelList(this.categoryId)
            }
          } else {
            if (index == 0) {
              ele.select = true;
              this.getChannelList(ele.category_id);
            } else {
              ele.select = false;
            }
          }
        });
        }
      else {
        this.getNewChannelList('')
      }
      }
      else
        {
        this.isLoading = false;
        this.utilService.hideSpinner()
        this.liveCategoryList = res;
        this.defaultCategoryList = res;
        this.searchedLiveCatList =this.liveCategoryList
        if (this.liveCategoryList) {
          this.liveCategoryList.map((ele: any, index) => {
          if (this.categoryId) {
            if (ele.category_id == this.categoryId) {
              ele.select = true;
              setTimeout(() => {
                //   document.getElementById("button" + ele.category_id).scrollIntoView();
                $(".category-box").animate({ scrollTop: $("#button" + ele.category_id).position().top }, 200, 'swing');
              }, 300);
              this.getChannelList(this.categoryId)
            }
          } else {
            if (index == 0) {
              ele.select = true;
              this.getChannelList(ele.category_id);
            } else {
              ele.select = false;
            }
          }
        });
        }
      else {
        this.getNewChannelList('')
      }
    }
    }, err => {
      this.isLoading = false;
      this.loadLiveTv = true;
      this.utilService.hideSpinner()
      this.utilService.showErrorCall(err);
    });

  }

  loadLiveTvData(){
    this.loadLiveTv = true;
    this.liveStreamService.getliveCategories().subscribe((res: any) => {
      if(res){
        this.loadLiveTv = false;
        this.isLoading = false;
        this.utilService.hideSpinner()
        this.liveCategoryList = res;
        this.defaultCategoryList = res;
        
        if (this.liveCategoryList) {
          this.liveCategoryList.map((ele: any, index) => {
          if (this.categoryId) {
            if (ele.category_id == this.categoryId) {
              ele.select = true;
              setTimeout(() => {
                //   document.getElementById("button" + ele.category_id).scrollIntoView();
                $(".category-box").animate({ scrollTop: $("#button" + ele.category_id).position().top }, 200, 'swing');
              }, 300);
              this.getChannelList(this.categoryId)
            }
          } else {
            if (index == 0) {
              ele.select = true;
              this.getChannelList(ele.category_id);
            } else {
              ele.select = false;
            }
          }
        });
      }
      else {
        this.getNewChannelList('')
      }
    }
    }, err => {
      this.isLoading = false;
      this.loadLiveTv = true;
      this.utilService.hideSpinner()
      this.utilService.showErrorCall(err);
    });
  }

  getNewChannelList(categoryId: any, isChange = null) {

    this.isChannelLoading = true;
    this.isLoading =true;
    this.utilService.showSpinner()
    // if condition for all data remove if else--getCategorywiseChannellist('')

    this.liveStreamService.getCategorywiseChannelLists().subscribe((res: any) => {
      this.utilService.hideSpinner()
      this.isChannelLoading = false;
      this.isLoading =false
      this.channels = res;
      // console.log("channels----", res);
      if (this.channels) {
        this.liveCategoryList.map((elecat: any, indexcat) => {
          if (elecat.category_id == categoryId)
            elecat.channelCount = this.channels.length;
        });//for channel count
        if(this.isLocal == true){
          let index, savedArray;
          savedArray = JSON.parse(localStorage.getItem(Constant.LIVETV_FAV)) || [];
          savedArray.map((ele: any) => {
            index = _.findIndex(this.channels, { stream_id: ele.id });
            if (index >= 0) {
              this.channels[index].isFavourit = true;
            }
          });//for favourit
        }else {
          let index;
          this.favData.map((ele: any) => {
            console.log(ele);
            
            index = _.findIndex(this.channels, { stream_id: ele.content_id });
            if (index >= 0) {
              this.channels[index].isFavourit = true;
            }
          });//for favourit
        }


        this.channels.map((ele: any, index) => { //during route channel

          if (this.selectedchannel && !isChange) {
            if (this.selectedchannel == ele.stream_id) {
              ele.select = true;
              setTimeout(() => {
                $("#channel-box").animate({
                  scrollTop:
                    $("#channel" + ele.stream_id).offset().top - $("#channel-box").offset().top
                }, 500, 'swing');
              }, 100);

              this.updateChannel(ele.stream_id,ele.links);
            }
          }
          else {
            if (index == 0) {
              ele.select = true;
              this.updateChannel(ele.stream_id,ele.links);
            } else {
              ele.select = false;
            }
          }
          // (index == 0) ? ele.select = true : ele.select = false;
          // if (ele.num == 1)
          //   this.updateChannel(ele.stream_id);
        });
      }
    }, err => {
      this.isChannelLoading = false;
      this.utilService.hideSpinner();
      this.utilService.showErrorCall(err);
    });
  }


  getChannelList(categoryId: any, isChange = null) {
    this.channelboxScroll.nativeElement.scrollTop = 0;
    this.utilService.showSpinner()
    this.isChannelLoading = true;
    // if condition for all data remove if else--
    if(categoryId === null){
      this.liveStreamService.getCategorywiseChannelLists().subscribe((res: any) => {
        this.isChannelLoading = false;
        this.utilService.hideSpinner()
        if(categoryId === null){
        this.channels = res;
        this.allCatSelected =true;
        this.channelImage = this.channels[0].stream_icon;
        this.channelname = this.channels[0].name;
        // this.liveUrl = this.channels[0].links;
        }else{
        this.channels = res;
        this.channelImage = this.channels[0].stream_icon
        this.channelname = this.channels[0].name;
        this.liveUrl = this.channels[0].links;

        this.catSelected =false;
        this.allCatSelected=false
        console.log("channel", res);
        if (this.channels) {
          this.liveCategoryList.map((elecat: any, indexcat) => {
            if (elecat.category_id == categoryId)
              elecat.channelCount = this.channels.length;
          });//for channel count
  
          let index, savedArray;
          savedArray = JSON.parse(localStorage.getItem(Constant.LIVETV_FAV)) || [];
          savedArray.map((ele: any) => {
            index = _.findIndex(this.channels, { stream_id: ele.id });
            if (index >= 0) {
              this.channels[index].isFavourit = true;
            }
          });//for favourit
  
          this.channels.map((ele: any, index) => { //during route channel
            if (this.selectedchannel && !isChange) {
              if (this.selectedchannel == ele.stream_id) {
                ele.select = true;
                setTimeout(() => {
                  //   document.getElementById("channel" + ele.stream_id).scrollIntoView();
                  $("#channel-box").animate({
                    scrollTop:
                      $("#channel" + ele.stream_id).offset().top - $("#channel-box").offset().top
                  }, 500, 'swing');
                }, 100);
  
                this.updateChannel(ele.stream_id,ele.links);
                this.updateChannelEpg(ele.stream_id, this.channelname ,this.channelImage)
  
              }
            }
            else {
              if (index == 0) {
                ele.select = true;
                this.updateChannel(ele.stream_id,ele.links);
                this.updateChannelEpg(ele.stream_id, this.channelname ,this.channelImage)
  
              } else {
                ele.select = false;
              }
            }
            // (index == 0) ? ele.select = true : ele.select = false;
            // if (ele.num == 1)
            //   this.updateChannel(ele.stream_id);
          });
        }
      }
      }, err => {
        this.isChannelLoading = false;
        this.utilService.hideSpinner()
        this.utilService.showErrorCall(err);
      });
    }else{
    this.liveStreamService.getCategorywiseChannelList(categoryId).subscribe((res: any) => {
      this.isChannelLoading = false;
      this.utilService.hideSpinner()
      if(categoryId === null){
      this.channels = res
      this.allCatSelected =true
      this.channelImage = this.channels[0].stream_icon
      this.channelname = this.channels[0].name;
      // this.liveUrl = this.channels[0].links;

      }else{
      // OneSteam functionality 
      if(res.content){
        this.channels = res.content;
        this.liveUrl = this.channels[0].links;

        if (this.channels) {
          this.liveCategoryList.map((elecat: any, indexcat) => {
            if (elecat.category_id == categoryId)
              elecat.channelCount = this.channels.length;
          });//for channel count
          if(this.isLocal == false){
            let index;
            this.favData.map((ele: any) => {
            index = _.findIndex(this.channels, { stream_id: ele.content_id })
            if (index >= 0) {
              this.channels[index].isFavourit = true;
            }
          });//for favourit

          }else{
            let index, savedArray;
            savedArray = JSON.parse(localStorage.getItem(Constant.LIVETV_FAV)) || [];
            savedArray.map((ele: any) => {
            index = _.findIndex(this.channels, { stream_id: ele.id });
            if (index >= 0) {
              this.channels[index].isFavourit = true;
            }
          });//for favourit
        }
  
          this.channels.map((ele: any, index) => { //during route channel
            if (this.selectedchannel && !isChange) {
              if (this.selectedchannel == ele.stream_id) {
                ele.select = true;
                setTimeout(() => {
                  //   document.getElementById("channel" + ele.stream_id).scrollIntoView();
                  $("#channel-box").animate({
                    scrollTop:
                      $("#channel" + ele.stream_id).offset().top - $("#channel-box").offset().top
                  }, 500, 'swing');
                }, 100);
  
                this.updateChannel(ele.stream_id,ele.links);
                this.updateChannelEpg(ele.stream_id, this.channelname ,this.channelImage)
  
              }
            }
            else {
              if (index == 0) {
                ele.select = true;
                this.updateChannel(ele.stream_id,ele.links);
                this.updateChannelEpg(ele.stream_id, this.channelname ,this.channelImage)
  
              } else {
                ele.select = false;
              }
            }
            // (index == 0) ? ele.select = true : ele.select = false;
            // if (ele.num == 1)
            //   this.updateChannel(ele.stream_id);
          });
        }
      }else{

        this.channels = res;
        this.channelImage = this.channels[0].stream_icon
        this.channelname = this.channels[0].name;
        this.liveUrl = this.channels[0].links;

        this.catSelected =false;
        this.allCatSelected=false
        if (this.channels) {
          this.liveCategoryList.map((elecat: any, indexcat) => {
            if (elecat.category_id == categoryId)
              elecat.channelCount = this.channels.length;
          });//for channel count
          if(this.isLocal == false){
            let index;
            this.favData.map((ele: any) => {
            console.log(ele);
            index = _.findIndex(this.channels, { stream_id: ele.content_id });
            if (index >= 0) {
              this.channels[index].isFavourit = true;
            }
          });//for favourit
          }else{

            let index, savedArray;
            savedArray = JSON.parse(localStorage.getItem(Constant.LIVETV_FAV)) || [];
            savedArray.map((ele: any) => {
              index = _.findIndex(this.channels, { stream_id: ele.id });
              if (index >= 0) {
                this.channels[index].isFavourit = true;
              }
            });//for favourit
          }
  
          this.channels.map((ele: any, index) => { //during route channel
            if (this.selectedchannel && !isChange) {
              if (this.selectedchannel == ele.stream_id) {
                ele.select = true;
                setTimeout(() => {
                  //   document.getElementById("channel" + ele.stream_id).scrollIntoView();
                  $("#channel-box").animate({
                    scrollTop:
                      $("#channel" + ele.stream_id).offset().top - $("#channel-box").offset().top
                  }, 500, 'swing');
                }, 100);
  
                this.updateChannel(ele.stream_id,ele.links);
                this.updateChannelEpg(ele.stream_id, this.channelname ,this.channelImage)
  
              }
            }
            else {
              if (index == 0) {
                ele.select = true;
                this.updateChannel(ele.stream_id,ele.links);
                this.updateChannelEpg(ele.stream_id, this.channelname ,this.channelImage)
  
              } else {
                ele.select = false;
              }
            }
            // (index == 0) ? ele.select = true : ele.select = false;
            // if (ele.num == 1)
            //   this.updateChannel(ele.stream_id);
          });
        }
      }
    }
    }, err => {
      this.isChannelLoading = false;
      this.utilService.hideSpinner()
      this.utilService.showErrorCall(err);
    });
  }
  }


  onCategoryChange(id: any, ischange: any) {
    // let btnId = "button" + id;
    // this.utilService.filterResetObservable.next(true);
    if(id === null){
      console.log(id,'ids............');
      this.getChannelList(id, ischange);
      this.liveCategoryList.map((ele: any, index) => {
        (ele.category_id == id) ? ele.select = true : ele.select = false;
      });
      
    }else{
      this.catSelected =false
      this.liveCategoryList.map((ele: any, index) => {
        (ele.category_id == id) ? ele.select = true : ele.select = false;
        // console.log("on change category",ele.category_id,"sdfad",id);
      });
      this.getChannelList(id, ischange);
    }

    // this.updateChannelEpg(id,id)
  }
 
  updateChannel(streamid,links) {
    console.log("update chanel", streamid);
   
     this.channels.map((ele: any, index) => {
      (ele.stream_id == streamid) ? ele.select = true : ele.select = false;
    });
    console.log(this.searchedChannel);
    // setTimeout(() => {
    //   this.updateChannelEpg(streamid, this.channelname ,this.channelImage);
    // }, 600);
    this.liveUrl = links;
    if(this.OToken)
      {
        if(this.formatType == '.m3u8'){
          this.Url = this.liveUrl.m3u8;
         localStorage.setItem("url", this.Url);
        }else if(this.formatType == '.ts'){
          this.Url = this.liveUrl.ts;
          localStorage.setItem("url", this.Url);
        }else{
          this.Url = this.liveUrl.m3u8;
          localStorage.setItem("url", this.Url);
        }
 
      }else{
        this.Url = this.liveStreamService.getStreamURL(streamid,this.formatType);
        localStorage.setItem("url", this.Url);
      }
    this.url = localStorage.getItem("url");
    console.log(this.url);
    
    setTimeout(() => {
      
      this.player = videojs('live-video',{
        controls:true,
        autoplay:true,
        preload:"auto",
        liveui:true
      }).src([{src:this.url,
        type:"application/x-mpegURL"
      }])
    }, 1000);
    
    var player = videojs('live-video');
    player.on('error', () => {
      var error = player.error();
      console.error('Video.js Error:', error);
  
      let errorMessage = '';
      switch (error.code) {
        case 4:
          errorMessage = 'The media could not be loaded, either because the server or network failed or because the format is not supported.';
          errorMessage = 'There is some error during playing the video. ';
          break;
        case 2:
          errorMessage = 'A network error caused the media download to fail part-way.';
          break;
        case 1:
          errorMessage = 'You aborted the video playback.';
          break;
        case 3:
          errorMessage = 'The video playback was aborted due to a corruption problem or because the video used features your browser did not support.';
          break;
        default:
          errorMessage = 'An unknown error occurred.';
          break;
      }
  
      player.errorDisplay.contentEl().innerHTML = `
        <div style="text-align: center; color: white;">
          <p>${errorMessage}</p>
          <button style="
            padding: 10px 20px;
            background-color: #007bff;
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            margin-top: 10px;
          " id="error_reload">Try again</button>
        </div>
      `;
  
      document.getElementById('error_reload')?.addEventListener('click', () => this.reloadVideo(streamid));
    });

   
      if (Hls.isSupported()) {
        this.hls = new Hls();
    
        this.hls.on(Hls.Events.MEDIA_ATTACHED, () => {
          this.hls.loadSource(this.url);
          this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
            // video.play();
            // video.load();
          });
  
        });
        this.hls.on(Hls.Events.ERROR, function (event, data) {
          if (data.fatal) {
            switch (data.type) {
              case Hls.ErrorTypes.MEDIA_ERROR:
                console.log('fatal media error encountered, try to recover');
                this.hls.recoverMediaError();
                break;
              case Hls.ErrorTypes.NETWORK_ERROR:
                console.error('fatal network error encountered', data);
                // setTimeout(() => {
                //   this.hls.loadSource(this.url);
                // }, 5000);
                if (this.hls) { 
                  
                  console.log('logs-----------------');
                  setTimeout(() => {
                    this.hls.loadSource(this.url);
                  }, 5000); 
                }
                break;
              default:
                
                this.hls.destroy();
                break;
            }
          }
        });
    }

    
  }
  
  reloadVideo(streamid){
  //  this.updateChannel(streamid)
  }

  updateChannelEpg(epgid, name, image) {
    
    console.log(epgid,name,image);
    this.epgId =epgid
    // setInterval  
    this.displayEpg = [];
    this.channelname = name;
    this.channelImage = image
    // console.log(this.channelname,'ch....name',this.channelImage,'channel images','epg id ',epgid);
    this.liveStreamService.getshortEpg(epgid).subscribe((res: any) => {
      // this.api.getcepg(epgid).subscribe(res => {
        console.log(res,'epg data.....');
        
        if (res.epg_listings.length>0) {
          
          this.epgdata = res.epg_listings;
          if (this.timer) {
            clearInterval(this.timer);
          }
          this.timer = setInterval(() => {   
            // console.log(this.epgdata[0].end - this.unixTime,this.unixTime,this.epgdata[0].end,'settimeout ');
            
            if(this.unixTime > this.epgdata[0].end ){
              this.updateChannelEpg(this.epgId, this.channelname, this.channelImage)
              clearInterval(this.timer)
            }
          }, 5000);
          
        const offset = -1 * new Date().getTimezoneOffset()
        for (let i = 0; i < this.epgdata.length; i++) {
          this.basetitle = atob(this.epgdata[i].title);
          this.basedesciption = atob(this.epgdata[i].description);
          // const start = moment.utc(this.epgdata[i].start).add(offset, 'minutes');
          // const end = moment.utc(this.epgdata[i].stop).add(offset, 'minutes');
          // const d2 = start.format('HH:mm');
          // const d3 = end.format('HH:mm');
          //
          const start = moment.unix(this.epgdata[i].start_timestamp).utc().add(offset, 'minutes');
          const end = moment.unix(this.epgdata[i].stop_timestamp).utc().add(offset, 'minutes');
          // Format times as HH:mm
          const d2 = start.format('HH:mm');
          const d3 = end.format('HH:mm');
          // this.channel_id = atob(this.epgdata[i].channel_id);
          // var d2 = moment(this.epgdata[i].start).add(offset, 'minutes').format('HH:mm');
          // var d3 = moment(this.epgdata[i].end).add(offset, 'minutes').format('HH:mm');
          // console.log("start",d2,start)
          // console.log("end",d3,end);
          // (this.utilService.getValueStorage(Constant.XSTREAMURL_KEY) ? (d3 = moment(this.epgdata[i].stop).add(offset, 'minutes').format('HH:mm')) : (d3 = moment(this.epgdata[i].end).add(offset, 'minutes').format('HH:mm')));
          const mjm = {
            title: this.basetitle,
            start: d2,
            end: d3,
            desc: this.basedesciption
          }
          this.displayEpg.push(mjm);
          //this.epgdata.push({endepg:this.epgdata[i].end})
          // var d5 = this.displayEpg[0].start;
          // d5 = d5.split(' ')[1];
          // var hms = d5;   // your input string
          // var a2 = hms.split(':'); // split it at the colons
          

          // var seconds2 = (+a2[0]) * 60 * 60 + (+a2[1]) * 60 + (+a2[2]);
          // console.log(seconds2);
          // localStorage.setItem('start', JSON.stringify(seconds2));
          
          
          // var d6 = this.epgdata[0].end;
          // d6 = d6.split(' ')[1];
          
          
          // var hms = d6;   // your input string
          // var a3 = hms.split(':'); // split it at the colons
          
          
          // var seconds3 = (+a3[0]) * 60 * 60 + (+a3[1]) * 60 + (+a3[2]);
          // console.log(seconds3);
          // localStorage.setItem('end', JSON.stringify(seconds3));
          // var duratione = seconds3 - seconds2;
          
          // console.log(duratione);
          // localStorage.setItem('duration', JSON.stringify(duratione));
        }
      }
    });
  }


  updateTime() {
    const date = new Date();
    // Convert the current time to Unix timestamp (seconds)
    this.unixTime = Math.floor(date.getTime() / 1000);
  }

 

  checkEpgTime(){
     interval(1000).subscribe(() => {
            const d = Date.now();
            let time = Math.floor(d/1000);
            const diff = 1713185280-time
        
          });
  }

  sort(property, subtype: any) {
   
    let ascDesc;
    if (subtype == 'default') {
      this.searchedLiveCatList = this.defaultCategoryList;
    } else {
      (subtype == 'atoz') ? ascDesc = 'asc' : ascDesc = 'desc';
    }
    if (ascDesc) {
      this.utilService.sortCommonCategorywise(property, ascDesc, this.searchedLiveCatList, (callback) => {
        this.searchedLiveCatList = callback;
      });
    }
    this.sortButton.map((ele: any) => {
      (subtype == ele.val) ? ele.selected = true : ele.selected = false;
    });
  }
  sortChannel(property,subtype:any){
    console.log(subtype);
    let ascDesc;
    
    if (subtype == 'default') {
      this.searchedChannel = this.defaultChannels;
    } else {
      (subtype == 'atoz') ? ascDesc = 'asc' : ascDesc = 'desc';
    }
    if (ascDesc) {
      this.utilService.sortCommonCategorywise(property, ascDesc, this.searchedChannel, (callback) => {
        this.searchedChannel = callback;
      });
    }
    this.sortButton.map((ele: any) => {
      (subtype == ele.val) ? ele.selected = true : ele.selected = false;
    });
  }
  

  onSave(item: any, ev: any) {
    ev.stopPropagation();

    if(this.isLocal == true){

    let savedArray = [];
    let isExist: any;
    let index;
    const msg=this.translate.instant('COMMON.ADDED_SUCCESS_MSG')

    savedArray = JSON.parse(localStorage.getItem(Constant.LIVETV_FAV)) || [];
    if (savedArray.length > 0) {
      isExist = _.findIndex(savedArray, { id: item.stream_id });
      if (isExist == -1) {
        item.isList = true;
        item.id = item.stream_id;
        item.fullUrl = localStorage.getItem(Constant.FULLURL_KEY);
        savedArray.push(item);
        console.log(item,'livetv items');
        
        localStorage.setItem(Constant.LIVETV_FAV, JSON.stringify(savedArray));
        index = _.findIndex(this.channels, { stream_id: item.stream_id });
        if (index >= 0) {
          this.channels[index].isFavourit = true;
        }

        this.utilService.showErrorSuccess(`${msg}`);
      }
      if (isExist >= 0) {
        this.utilService.showErrorInfo('Item alreadey added to favourite')
      }

    }
    else { //first
      item.isList = true;
      item.id = item.stream_id;
      item.fullUrl = localStorage.getItem(Constant.FULLURL_KEY);
      savedArray.push(item);
      localStorage.setItem(Constant.LIVETV_FAV, JSON.stringify(savedArray));
      index = _.findIndex(this.channels, { stream_id: item.stream_id });
      if (index >= 0) {
        this.channels[index].isFavourit = true;
      }
      this.utilService.showErrorSuccess(msg);

    }
  }else{
    const extension = item.container_extension;
    this.Url = this.liveStreamService.getStreamURL(item.stream_id,this.formatType);
    
    const urls = [this.Url ,item.stream_icon,item.category_id];
    
    const body = {
      profile_id:this.profile_id,
      content_type: 'live',
      content_id: item.stream_id,
      content_url: urls
    }
    console.log(body);
     
    this.playlistService.addFavorites(body).subscribe((res:any) =>{
      console.log(res);
      this.getFavData()
    })
  }


  }



  deleteFavourite(item: any, ev: any) {
    ev.stopPropagation();
    const msg=this.translate.instant('COMMON.REMOVE_SUCCESS_MSG')
    if(this.isLocal == true){
      item.id = item.stream_id;
    }else{
      const stream_id = item.stream_id;
      console.log(stream_id);
      this.favData = this.favData.filter( type => type.content_type == 'live' && type.content_id == stream_id);
      this.fav_id = this.favData[0].favorite_id;
      
    }
    this.utilService.deleteFavourit(Constant.LIVETV_FAV, item, (result: any) => {
      
      if (result == 0) {
        if(this.isLocal == true){
          
          this.utilService.showErrorSuccess(`${msg}`);
          let index = _.findIndex(this.channels, { stream_id: item.id });
          if (index >= 0) {
            this.channels[index].isFavourit = false;
          }
        }else{
          this.playlistService.removeFavorites(this.fav_id).subscribe((res:any) =>{
            if(res){
            console.log(res.message);
            this.utilService.showSuccess(res?.message)
            this.getFavData();
            }
          })

        }
      }
    });
  }


  /** 
  togglevideo(){
      if(!this.videoPlaying){
        this.video.play();
        this.videoPlaying = true;
      }else{
        this.video.pause();
        this.videoPlaying = false;
      }*/

  onTimeUpdate() {
    //console.log(this.video.currentTime);
    //console.log(this.video.duration);

    var today = new Date();

    var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    var dateTime = date + ' ' + time;
    this.timedata = dateTime;
    //console.log(dateTime);

    this.start = localStorage.getItem('start');
    this.end = localStorage.getItem('end');
    this.hello = localStorage.getItem('duration');
    // console.log(this.end);
    this.percentage = (this.video.currentTime * 100 / this.hello);
    // console.log(this.percentage);
  }
  ngOnDestroy() {
    // this.hls.destroy();
    this.player = videojs('live-video');
    this.player.dispose()
    // this.video.pause();
    if (this.sortType) {
      this.subscription.unsubscribe();
    }
    
    clearInterval(this.timer);
    clearInterval(this.currentTimer);
  }

  //test video 
  videoSource = "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4";

  @ViewChild('videoPlayer') videoplayer: any;
  public startedPlay: boolean = false;
  public show: boolean = false;
  pauseVideo(videoplayer) {
    videoplayer.nativeElement.play();
    // this.startedPlay = true;
    // if(this.startedPlay == true)
    // {
    setTimeout(() => {
      videoplayer.nativeElement.pause();
      if (videoplayer.nativeElement.paused) {
        this.show = !this.show;
      }
    }, 5000);
    // }
  }

  closebutton(videoplayer) {
    this.show = !this.show;
    videoplayer.nativeElement.play();
  }

  // private setupPlyr() {
  //   const videoElement = this.elementRef.nativeElement.querySelector('video');

  //   this.plyrInstance = new Plyr(videoElement, {
  //     controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'settings', 'pip', 'airplay', 'fullscreen'],
  //     tooltips: { controls: false },
  //     playlist: {
  //       enabled: true,
  //       loop: { active: true },
  //       autoadvance: { autoplay: true, delay: 5000 },
  //       items: [
  //         {
  //           title: 'Video 1',
  //           sources: [
  //             {
  //               src: this.url,
  //               type: 'application/x-mpegURL'
  //             }
  //           ]
  //         },
  //       ]
  //     }
  //   });
  // }

  openInVLC(urlForVlc) {
    if (urlForVlc) {
      if (window.navigator.platform.startsWith('Win')) {
      // this.vlcUrl = `vlc:open/${urlForVlc}`;
     this.vlcUrl=`vlc://open?url=${encodeURIComponent(urlForVlc)}`
      window.location.href = this.vlcUrl
      // window.open(this.vlcUrl)
    }
      else if (window.navigator.platform.startsWith('Mac')) {
        this.vlcUrl = `open -a "VLC" "${urlForVlc}"`;
      }else{
        this.vlcUrl=`vlc"${urlForVlc}"`
      }
      // window.open(this.vlcUrl);
    }
    else {
      this.utilService.showErrorCall("Url Not Found")
    }

  }

  copyUrl(url) {
    const el = document.createElement('textarea');
    el.value = url;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    const success = 'Url copied successfully ,After opening VLC Player paste Url (Ctrl+v)'
    this.utilService.showSuccess(success)
    this.openInVLC(url)
  }

  downloadRegistryFile() {
    const registryFileContent = `Windows Registry Editor Version 5.00
    [HKEY_CLASSES_ROOT\vlc]
    @="URL:VLC Protocol"
    "URL Protocol"=""
    [HKEY_CLASSES_ROOT\vlc\shell]
    [HKEY_CLASSES_ROOT\vlc\shell\open]
    [HKEY_CLASSES_ROOT\vlc\shell\open\command]
    @="\"C:\\Program Files\\VideoLAN\\VLC\\vlc.exe\" \"%1\""
    `;
    const blob = new Blob([registryFileContent], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'vlc.reg';
    link.click();
    window.URL.revokeObjectURL(url);
  }

  onClickOpenVLC(url: string) {

    const serverUrl = 'http://localhost:3000/open-vlc';
    const fullUrl = `${serverUrl}?url=${url}`;
  
    this.http.get(fullUrl).subscribe(
      () => {
        console.log('VLC command sent successfully');
      },
      (error) => {
        window.open('https://www.videolan.org/vlc/', '_blank');
      }
    );
  }
  openVlc(url) {
    // const urls = `https://dazzling-buttercream-4df76e.netlify.app/.netlify/functions/api/play?url=${encodeURIComponent(url)}`;
    // const urls = `    https://quiet-alpaca-a36ba3.netlify.app/.netlify/functions/api?url=${encodeURIComponent(url)}`;
    const urls = `http://localhost:3000/play?url=${encodeURIComponent(url)}`;

    this.http.get(urls).subscribe(
      response => {
        console.log(response);
      },
      error => {
        if (error.status === 500){
        window.open('https://www.videolan.org/vlc/', '_blank');
        }
      }
    );
  }
  
  openVlcs(url: string): void {
    this.utilService.send('start', url);
  }
  sorts(type: any, subCategory: any) {
    let passModal: any = {
      type: type,
      sub_category: subCategory
    };
    this.sortButton.map((ele: any) => {
      (subCategory == ele.val) ? ele.selected = true : ele.selected = false;
    });
    this.utilService.addSorting(passModal);
  }

  resetSort() {
    this.sortButton.map((ele: any) => {
      ele.selected = false;
      return ele;
    });
    this.sortButton[0].selected = true;
  }
  translateFilter(index:any):string{
    return this.translation[index]
  }

}
